import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import "animate.css";

import "./Testimonials.css";

import { CustomCarousel } from "./CustomCarousel";

export const Testimonials = () => {
  const { t } = useTranslation();

  return (
    <section className="testimonials" id="testimonials">
      <Container>
        <Row className="align-items-center justify-content-center">
        <Col size={12} sm={9}>
            <div className="animate__animated animate__fadeIn">
              <h2>{t("testimonials.title")}</h2>
              <p className="subtitle">
                {t("testimonials.subtitle")}
              </p>

              <CustomCarousel />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
